export const setCheckedParameters = (currArr, appendVal, checked) => {
	if (!checked) {
		return currArr.filter((value) => value !== appendVal);
	}
	return [...currArr, appendVal];
};
